import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ApolloProvider } from '@apollo/client';
import apolloClient from './config/ApolloClient';
import 'raf/polyfill';
import { BrandConfiguration } from 'toca-config';
import ContextStore from './store/ContextStore';

let brand = BrandConfiguration.GetBrandConfiguration();
const rootEl = document.getElementById('root');

const updateFavicon = () => {
  const link = document.querySelector('link[rel="shortcut icon"]');
  link.attributes['href'].value = brand.brandConfiguration.favicon;
};

const Root = () => (
  updateFavicon(),
  (document.title = brand.brandConfiguration.name),
  (
    <ApolloProvider client={apolloClient}>
      <ContextStore>
        <App />
      </ContextStore>
    </ApolloProvider>
  )
);
ReactDOM.render(<Root />, rootEl);
serviceWorker.unregister();

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    ReactDOM.render(
      <ApolloProvider client={apolloClient}>
        <NextApp />
      </ApolloProvider>,
      rootEl
    );
  });
}
